<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：门店列表
      -->
  <div class="user">
    <!--添加门店-->
    <div style='display: flex;justify-content: space-between;'>
      <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus"
          @click="addClick">生成CDK</el-button></div>

      <div class="common-level-rail" style="display: flex;justify-content: flex-start;">
        <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline"
          style="display: flex;justify-content: flex-start;">
          <el-form-item label="CDK编号" style="margin-bottom:0!important">
            <el-input size="small" v-model="searchForm.code" placeholder="请输入CDK编号"></el-input>
          </el-form-item>
          <el-form-item label="兑换状态" style="margin-bottom:0!important">
            <el-select size="small" v-model="searchForm.is_effective" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="已兑换" value="1"></el-option>
              <el-option label="未兑换" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="common-level-rail" style="margin-bottom:0!important;margin-right:20px;"><el-button size="small"
              type="primary" icon="el-icon-search" @click="searchClick">搜索</el-button></div>
        </el-form>
        <el-button size="small" type="danger" icon="el-icon-download" @click="dowAllClick">导出当页</el-button>
      </div>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="code" label="CDK编码"></el-table-column>
          <el-table-column prop="point" label="奖励积分"></el-table-column>
          <el-table-column v-if="false" prop="product_id" label="商品id"></el-table-column>
          <el-table-column prop="product_name" label="商品名称"></el-table-column>
          <el-table-column label="商品规格">
            <template slot-scope="scope">
              <span v-if='!scope.row.product_id'></span>
              <span v-if='scope.row.product_id && !scope.row.spec_sku_id'>默认规格</span>
              <span v-if='scope.row.spec_sku_id'>{{ scope.row.spec_sku_id }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="false" prop="product_sku_id" label="商品skuid"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <span class="green" v-if='scope.row.is_effective == 1'>已兑换</span>
              <span class="gray" v-if='scope.row.is_effective == 0'>未兑换</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="dowClick(scope.row)" type="text" size="small">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-dialog title="导出" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="导出数量" prop="number" :rules="[{ required: true, message: ' ' }]">
            <el-input type="number" v-model="form.number" placeholder="请输入导出数量" class="max-w460"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dowAllClick">确 定</el-button>
        </div>
      </el-dialog> -->
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import {StoreApi} from '@/api/store.js';
import StoreApi from '@/api/store.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      searchForm: {
        code: "",
        is_effective: ''
      },
      dialogFormVisible: false,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 100,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      form: {
        number: 0
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    searchClick() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },
    dowAllClick() {
      var fileName = new Date().getTime() + ".png";
      let self = this;
      StoreApi.dowAllErweima({ page: self.curPage, list_rows: self.pageSize }, true).then(data => {
        // self.fileHandle(data.msg,fileName);
        window.open(data.msg)
      })
        .catch(error => { });
    },
    dowClick(row) {
      var fileName = new Date().getTime() + ".png";
      let self = this;
      StoreApi.dowErweima({ id: row.id }, true)
        .then(data => {
          self.downloadIamge(data.msg.path.toString(), fileName);
        })
        .catch(error => { });
    },
    fileHandle(data, fileName) {
      let blob = new Blob([data], { type: 'application/zip' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a') // 创建a标签
      link.href = url
      link.download = fileName // 重命名文件
      link.click()
      URL.revokeObjectURL(url) // 释放内存
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        }); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.code = self.searchForm.code
      Params.is_effective = self.searchForm.is_effective
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      StoreApi.cdkList(Params, true).then(data => {
        self.loading = false;
        self.tableData = data.msg.list
        self.totalDataNumber = data.msg.total;
      })
        .catch(error => { });
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/appsetting/cdk/add');
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.id;
      this.$router.push({
        path: '/appsetting/banner/edit',
        // name: 'mallList',
        query: {
          id: params
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          StoreApi.deleteBanner(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => { });
        })
        .catch(() => { });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/appsetting/cdk/index.vue